import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const OsanoScript = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (
      !/^\/(sign-up|application)(\/|$)/i.test(pathname) ||
      document.getElementById('osano-script')
    ) {
      return;
    }

    const script = document.createElement('script');
    script.id = 'osano-script';
    // Use Marketing's configuration so Osano shares consent on medely.com and its subdomains.
    script.src =
      'https://cmp.osano.com/AzqSL3SzX6Tem2q5E/3c6f62a6-69d8-4ae0-90dc-912f2ba9e7b0/osano.js';
    document.head.appendChild(script);

    // Keep the instance across navigation: removing the tag does not undo Osano's global state.
  }, [pathname]);

  return null;
};

export default OsanoScript;
